import React, {Component} from "react"
import {Button, Dropdown, Form, Message, Segment,} from "semantic-ui-react";
import {withRouter} from "react-router-dom";
import {getLocalization} from "../utils/localization";
import {connect} from "react-redux";
import axios from 'axios';
import {DateInput} from "semantic-ui-calendar-react-yz";
import {CustomEmailInput, CustomGrid} from "./custom-common";

import {API_URL} from "../utils/config";

const mapStateToProps = (state, ownProps) => {
    const {user} = state;

    return {
        ...ownProps,
        lang: user.lang,
        name: user.name
    }
};

class SignUp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: !!props.name? props.name : '',
            lastName: '',
            email: '',
            password: '',
            plan: 'GOOD',
            dob: '',
            error: false,
            formSubmittedOk: false,
            submitError: '',
            loading: false,
        };
    }

    submit = async () => {
        const {name, lastName, email, password, plan, dob} = this.state;
        if (name.length === 0 || lastName.length === 0 || email.length === 0 || password.length === 0 || plan.length === 0| dob.length === 0) {
            this.setState({error: true});
        } else {
            this.setState({loading: true, error: false, submitError: false});
            try {
                await axios.post(`${API_URL}/signUp`, {
                    firstName: name,
                    lastName: lastName,
                    email: email,
                    password: password,
                    plan: plan,
                    dateOfBirth: `${dob}T00:00:00Z`
                });
                this.setState({formSubmittedOk: true, submitError: '', loading: false});
            } catch(e) {
                if (!!e && !!e.response && !!e.response.data){
                    console.log(e.response.data);
                }
                this.setState({
                    loading: false,
                    formSubmittedOk: false,
                    submitError: e.message,
                })
            }
        }
    };

    handleFormChange(name, value) {
        this.setState({
            [name]: value,
            error: false,
            submitError: false,
        });
    }

    render() {
        const localization = getLocalization(this.props.lang);
        const strings = localization.signUp;
        const {email, password} = localization;
        const stringPlans = localization.recommendedPlans;
        return (
            <React.Fragment>
                <CustomGrid container stackable columns={3}>
                    <CustomGrid.Column />
                    <CustomGrid.Column textAlign='left'>
                        <Segment>
                            <Form>
                                <Form.Field required>
                                    <label>{strings.firstName}</label>
                                    <input placeholder={""} value={this.state.name} onChange={(e) => {
                                        this.handleFormChange("name", e.target.value);
                                    }}/>
                                </Form.Field>

                                <Form.Field required>
                                    <label>{strings.lastName}</label>
                                    <input placeholder={""} value={this.state.lastName} onChange={(e) => {
                                        this.handleFormChange("lastName", e.target.value);
                                    }}/>
                                </Form.Field>

                                <Form.Field required>
                                    <label>{strings.dateOfBirth}</label>
                                    <DateInput
                                        animation={null}
                                        value={this.state.dob}
                                        iconPosition="right"
                                        dateFormat={"YYYY-MM-DD"}
                                        onChange={(e, {value}) => {
                                            this.handleFormChange("dob", value);
                                        }}
                                    />
                                </Form.Field>

                                <Form.Field required>
                                    <CustomEmailInput 
                                        placeholder={""}
                                        label={email}
                                        value={this.state.email}
                                        onChange={(e) => {
                                            this.handleFormChange("email", e.target.value);
                                        }}
                                    />
                                </Form.Field>

                                <Form.Field required>
                                    <label>{password}</label>
                                    <input placeholder={""} type={"password"} value={this.state.password}
                                           onChange={(e) => {
                                               this.handleFormChange("password", e.target.value);
                                           }}/>
                                </Form.Field>

                                <Form.Field required>
                                    <label>{strings.plan}</label>
                                    <Dropdown value={this.state.plan} selection
                                              onChange={(e, {value}) => {
                                                  this.handleFormChange("plan", value);
                                              }}
                                              options={[
                                                  {key: 1, text: stringPlans.good, value: "GOOD"},
                                                  {key: 2, text: stringPlans.best, value: "BEST"},
                                                  {key: 3, text: stringPlans.better, value: "BETTER"}
                                              ]}/>
                                </Form.Field>

                                {!!this.state.error && <Form.Field><Message negative>Please complete all required fields</Message></Form.Field>}
                                {!!this.state.submitError && <Form.Field><Message negative>{this.state.submitError}</Message></Form.Field>}

                                <Form.Field>
                                    <Button loading={this.state.loading} primary fluid onClick={this.submit}>{strings.signUp}</Button>
                                </Form.Field>
                            </Form>
                        </Segment>
                    </CustomGrid.Column>
                </CustomGrid>
            </React.Fragment>
        )
    }
}

export default withRouter(connect(mapStateToProps)(SignUp));